//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "DCOIDIC",
  data() {
    return {
      form: {
        crowd: "",
        medianUrinaryIodine: "",
      },
      result:'',
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "1", name: "儿童（2岁以上）" },
        { value: "0", name: "2岁以下婴儿" },
      ],
      dataList2: [
        { value: "0", name: "＜100" },
        { value: "1", name: "100~" },
        { value: "2", name: "200~" },
        { value: "3", name: "≥300" },
      ],
      dataList3: [
        { value: "0", name: "＜100" },
        { value: "1", name: "≥100" },
      ],
    };
  },
  watch:{
    'form.crowd':function(n,o) {
      console.log(n,o,999);
      if(String(o) && n != o) {
        this.form.medianUrinaryIodine = ''
      }
     
    }
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        if(form.crowd == 1) {
          if(form.medianUrinaryIodine == 0) {
            self.result = '不足'
          } else if(form.medianUrinaryIodine == 1) {
            self.result = '适宜'
          } else if(form.medianUrinaryIodine == 2) {
            self.result = '超过适宜量'
          } else {
            self.result = '过量'
          }
        } else {
          if(form.medianUrinaryIodine == 0) {
            self.result = '不足'
          } else {
            self.result = '适宜'
          }
        }
        return self.result;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DCOIDIC.vue